import { combineReducers } from 'redux';

import state from './reducers/state';
import user from './reducers/user';

export default combineReducers({
  state,
  user,
});
